import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  createRecruitmentFailed,
  createRecruitmentStart,
  createRecruitmentSuccess,
} from "../redux/createRecruitment";
import { formInputRecruitmentSelector } from "../redux/selector";
import { createRecruitmentRqApi } from "core/http/service/recruitment";
import {
  getListRecruitmentRequirementStart,
  resetListRecruitmentRequirement,
} from "../redux/getListRecruitmentRequirement";
import { toast } from "react-toastify";
import { formRecruitmentReset } from "../redux/formInput";
import { changeFormErrors } from "redux-store/static/redux/validation";
import { GLOBAL_VALIDATION } from "helper/enum/globalValidation";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";

function* createRecruitmentWork(action) {
  const { callBack } = action.payload;
  const formData = yield select(formInputRecruitmentSelector);

  try {
    const newForm = {
      ...formData,
      departmentCode:
        formData?.departmentLevel3Code ||
        formData?.departmentLevel2Code ||
        formData?.departmentLevel1Code,

      filePath: JSON.stringify(formData?.files),
      specializedCode: formData?.specializedCode?.map((it) => it?.value),
      practiceCertificateCode: formData?.practiceCertificateCode?.map(
        (it) => it?.value
      ),
      languageLevelCode: formData?.languageLevelCode?.map((it) => it?.value),
      relatePerson:
        (formData?.relatePerson || []).length > 0
          ? formData?.relatePerson.map((it) => it?.value).join(",")
          : ``,
    };
    const res = yield call(createRecruitmentRqApi, newForm);
    if (!res) return;
    yield put({
      type: createRecruitmentSuccess.type,
    });

    yield put({
      type: resetListRecruitmentRequirement.type,
    });

    yield put({
      type: formRecruitmentReset.type,
    });

    yield put({
      type: resetControlPage.type,
      payload: "recruitmentRequirement",
    });

    yield put({
      type: getListRecruitmentRequirementStart.type,
    });

    callBack?.();
    toast.success("Thêm mới yêu cầu tuyển dụng thành công!");
  } catch (error) {
    yield put({
      type: createRecruitmentFailed.type,
    });
    if (error?.response?.data?.validate_errors) {
      const err = error?.response?.data?.validate_errors;
      const newErr = {};
      err?.forEach((element) => {
        newErr[element?.dataInput] = element?.code;
      });

      yield put({
        type: changeFormErrors.type,
        payload: {
          key: GLOBAL_VALIDATION.CREATE_UPDATE_RECRUITMENT_REQ,
          payload: (prevState) => ({
            isScrollToFirstError: false,
            formErrors: {
              ...prevState.formErrors,
              ...newErr,
            },
          }),
        },
      });
    } else {
      toast.error(
        error?.response?.data?.message || "Đã có lỗi xảy ra lúc tạo đơn!"
      );
    }
  }
}

function* watchCreateRecruitment() {
  yield takeLatest(createRecruitmentStart.type, createRecruitmentWork);
}

export default function* createRecruitmentSaga() {
  yield all([watchCreateRecruitment()]);
}
